<div class="version-number {{absolutePlacement ? 'absolute' : ''}}">{{year}}.{{quarter}} ({{commit}})</div>